module.exports = __webpack_public_path__ + "static/img/rank_128.41a5784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_128.png
// module id = GOVJ
// module chunks = 1